import axios from 'axios';

const FETCH_SHIPMENTS = 'preSeason/FETCH_SHIPMENTS';
const SAVE_SHIPMENT = 'preSeason/UPDATE_CURRENT_SHIPMENT';
const DELETE_SHIPMENT = 'preSeason/DELETE_SHIPMENT';
const ADD_SHIPMENT = 'preSeason/ADD_SHIPMENT';
const UPDATE_VALIDATORS = 'preSeason/UPDATE_VALIDATORS';
const SET_ORDER_FORM_TYPE = 'preSeason/SET_ORDER_FORM_TYPE';

const preSeason = {
  namespaced: true,
  state: {
    shipments: {},
    currentShipment: {},
    validators: [],
    orderFormType: null,
  },
  getters: {
    shipments: (state) => state.shipments,
    validators: (state) => state.validators,
    orderFormType: (state) => state.orderFormType,
  },
  mutations: {
    [FETCH_SHIPMENTS](state, payload) {
      state.shipments = payload;
    },
    [SAVE_SHIPMENT](state, payload) {
      state.shipments = payload;
    },
    [DELETE_SHIPMENT](state, shipmentNumber) {
      state.shipments.splice(shipmentNumber, 1);
    },
    [ADD_SHIPMENT](state, newShipment) {
      state.shipments.push(newShipment);
    },
    [UPDATE_VALIDATORS](state, validator) {
      state.validators.push(validator);
    },
    [SET_ORDER_FORM_TYPE](state, orderFormType) {
      state.orderFormType = orderFormType;
    },
  },
  actions: {
    async fetchShipments({commit}, orderFormType) {
      const shipmentData = await axios.get(`pre-season-orders-api/shipments/${orderFormType}/`);
      let shipmentList = shipmentData.data.data.orderShipments;
      commit(FETCH_SHIPMENTS, shipmentList);
    },
    async saveShipment({commit, state}) {
      let shipmentData = {
        preseasonOrderType: state.orderFormType,
        orderShipments: state.shipments,
      };
      return await axios
        .post(`pre-season-orders-api/save-shipments`, shipmentData)
        .then((submitResponse) => {
          commit(SAVE_SHIPMENT, submitResponse.data.data.orderShipments);
          return submitResponse;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    deleteShipment({commit}, shipmentNumber) {
      commit(DELETE_SHIPMENT, shipmentNumber);
    },
    addShipment({commit}, newShipment) {
      commit(ADD_SHIPMENT, newShipment);
    },
    async updateValidators({commit}, validator) {
      await commit(UPDATE_VALIDATORS, validator);
    },
    setOrderFormType({commit}, orderFormType) {
      commit(SET_ORDER_FORM_TYPE, orderFormType);
    },
  },
};

export default preSeason;
